export {};

declare global {
  interface Date {
    string(): string;
    dateString(): string;
  }
}

const f = (n: number) => {
  return n.toString().padStart(2, "0");
};

Date.prototype.string = function (): string {
  return `${this.getFullYear()}/${f(this.getMonth() + 1)}/${f(this.getDate())} ${f(this.getHours())}:${f(
    this.getMinutes()
  )}`;
};

Date.prototype.dateString = function (): string {
  return `${this.getFullYear()}/${f(this.getMonth() + 1)}/${f(this.getDate())}`;
};
